import axios from "axios";

export const URL = "https://server.soop.asia/api";
export var PHONE_NUMBER:string = '(+60)12 379 4701 / (+60)12 646 7725';
export var SINGLE_PHONE:string = '(+60)12 379 4701';
export var ADDRESS1:string = 'NO.27 Jalan 3/898 Off Batu 31/2 Jalan Sg.Besi, Seksyen 92 55200 Kuala Lumpur Wilayah Persekutuan';
export var EMAIL:string = 'admin@megametal.my';
export var COMPANY_NAME:string = 'Metal';
export var COMPANY_PREFIX:string = 'MEGAMETAL';
export const MAP_KEY:string = "AIzaSyACrivko1BWYpVt9GHmD_KfDPUARBwvl6c";
export var lat:number = 3.12057;
export var lng:number = 101.69197;
axios.defaults.baseURL = URL;

